import {useMutation} from '@tanstack/react-query';
import IWBrokerClient from '../client/IWBrokerClient';

export function useReceptionDoorUnlockMutation() {
    return useMutation({
        mutationKey: ['00/reception/door/sliding unlock'],
        mutationFn: async () => IWBrokerClient.volatileRequest('00/reception/door/sliding unlock')
    });
}

export function useReceptionDoorSlideOpenMutation() {
    return useMutation({
        mutationKey: ['00/reception/door/sliding'],
        mutationFn: async () => IWBrokerClient.volatileRequest('00/reception/door/sliding', true)
    });
}
